var map = {
	"./1.jpg": 1006,
	"./2.jpg": 1007,
	"./3.jpg": 1008,
	"./4.jpg": 1009,
	"./5.jpg": 1010,
	"./AvatarMaestra.jpg": 90,
	"./AvatarMaestro.jpg": 89,
	"./Female.jpg": 348,
	"./Female2.jpg": 267,
	"./Male.jpg": 347,
	"./Male2.jpg": 266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 551;